import { userHasPermission } from './logic/contactLinking';
import type { PermissionValue, ProjectMember, Role } from './types';

interface ProjectPermissionInput {
  cloudEnabled: boolean;
  member: ProjectMember | null | undefined;
  permission: PermissionValue;
  roles: Role[];
  user: unknown;
}

export function canUseProjectPermission({
  cloudEnabled,
  member,
  permission,
  roles,
  user,
}: ProjectPermissionInput): boolean {
  if (cloudEnabled && !user) {
    return false;
  }

  if (member === null) {
    return true;
  }

  return userHasPermission(member, roles, permission);
}
